import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import { TemplateSixPDFSection } from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
}: {
  heading: string;
  summary: string;
  themeColor: string;
}) => {
  return (
    <TemplateSixPDFSection themeColor={themeColor} heading={heading}>
      <View wrap={false}>{summary && <ResumePDFText>{summary}</ResumePDFText>}</View>
    </TemplateSixPDFSection>
  );
};
